// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uguS","label":"styles_label__2AJ8J"};